"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.errorHandler = void 0;
const restless_1 = require("@restless/restless");
const errors_1 = require("./errors");
function preprocessError(error) {
    if (error instanceof errors_1.HttpAwareError) {
        return error;
    }
    if (error instanceof restless_1.SanitizeError) {
        return new errors_1.InvalidRequest(error.errors);
    }
    if (error instanceof Error) {
        return new errors_1.HttpAwareError(error.message, `UNKNOWN_${error.constructor.name.toUpperCase()}`, 500);
    }
    else {
        return new errors_1.HttpAwareError('An unknown error occurred', 'UNKNOWN_UNRECOGNIZED_ERROR', 500);
    }
}
const errorHandler = (err, _req, res, _next) => {
    const error = preprocessError(err);
    res.status(error.status);
    res.send(error.JSON());
};
exports.errorHandler = errorHandler;
//# sourceMappingURL=errorHandler.js.map